var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28.352,
    height: 28.33,
    viewBox: "0 0 28.352 28.33",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-68.768 -0.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M82.94.09A14.172,14.172,0,0,0,71.03,21.94l-2.15,4.74a1.209,1.209,0,0,0,.19,1.31,1.227,1.227,0,0,0,.94.43,1.242,1.242,0,0,0,.33-.04l5.93-1.63A14.168,14.168,0,1,0,82.94.09Zm0,25.87a11.694,11.694,0,0,1-5.89-1.59,1.258,1.258,0,0,0-.62-.17,1.242,1.242,0,0,0-.33.04L72.22,25.3l1.35-2.97a1.254,1.254,0,0,0-.12-1.24,11.694,11.694,0,1,1,9.49,4.87Z",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M88.38,16.38a2.471,2.471,0,0,0-2.07-.47c-.54.22-.88,1.06-1.23,1.49a.519.519,0,0,1-.67.14,9.373,9.373,0,0,1-4.67-4,.575.575,0,0,1,.07-.78,3.112,3.112,0,0,0,.85-1.38,3.019,3.019,0,0,0-.38-1.63,3.857,3.857,0,0,0-1.2-1.81,1.631,1.631,0,0,0-1.79.27,3.634,3.634,0,0,0-1.26,2.88,3.909,3.909,0,0,0,.11.91,7.251,7.251,0,0,0,.88,2.02,15.91,15.91,0,0,0,.92,1.39,14.214,14.214,0,0,0,3.97,3.68,12.722,12.722,0,0,0,2.47,1.18,5.589,5.589,0,0,0,2.88.46,3.484,3.484,0,0,0,2.61-1.94,1.687,1.687,0,0,0,.12-.99C89.86,17.12,88.94,16.71,88.38,16.38Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Whatsapp.6f71e57e.svg";
export { ForwardRef as ReactComponent };